"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.deleteFile = deleteFile, exports.writeMetadataToDb = writeMetadataToDb, exports.uploadFileWithProgress = uploadFileWithProgress;

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined")),
    _omitBy2 = _interopRequireDefault(require("lodash/omitBy")),
    _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FILE_UPLOAD_ERROR = _constants.actionTypes.FILE_UPLOAD_ERROR,
    FILE_UPLOAD_PROGRESS = _constants.actionTypes.FILE_UPLOAD_PROGRESS;

function deleteFile(firebase, _ref) {
  var path = _ref.path,
      dbPath = _ref.dbPath;
  return firebase.storage().ref(path).delete().then(function () {
    if (!dbPath || !firebase.database && !firebase.firestore) return {
      path: path
    };
    return function metaDeletePromise() {
      return firebase._.config.useFirestoreForStorageMeta ? firebase.firestore().doc(dbPath).delete() : firebase.database().ref(dbPath).remove();
    }().then(function () {
      return {
        path: path,
        dbPath: dbPath
      };
    });
  });
}

function createUploadMetaResponseHandler(_ref2) {
  var fileData = _ref2.fileData,
      firebase = _ref2.firebase,
      uploadTaskSnapshot = _ref2.uploadTaskSnapshot,
      downloadURL = _ref2.downloadURL;
  return function (metaDataSnapshot) {
    var useFirestoreForStorageMeta = firebase._.config.useFirestoreForStorageMeta,
        result = {
      snapshot: metaDataSnapshot,
      key: metaDataSnapshot.key || metaDataSnapshot.id,
      File: fileData,
      metaDataSnapshot: metaDataSnapshot,
      uploadTaskSnapshot: uploadTaskSnapshot,
      uploadTaskSnaphot: uploadTaskSnapshot,
      createdAt: useFirestoreForStorageMeta ? firebase.firestore.FieldValue.serverTimestamp() : firebase.database.ServerValue.TIMESTAMP
    };
    return metaDataSnapshot.id && (result.id = metaDataSnapshot.id), downloadURL && (result.downloadURL = downloadURL), result;
  };
}

function getDownloadURLFromUploadTaskSnapshot(uploadTaskSnapshot) {
  return uploadTaskSnapshot.ref && "function" == typeof uploadTaskSnapshot.ref.getDownloadURL ? uploadTaskSnapshot.ref.getDownloadURL() : Promise.resolve(uploadTaskSnapshot.downloadURLs && uploadTaskSnapshot.downloadURLs[0]);
}

function writeMetadataToDb(_ref3) {
  var firebase = _ref3.firebase,
      uploadTaskSnapshot = _ref3.uploadTaskSnapshot,
      dbPath = _ref3.dbPath,
      options = _ref3.options,
      _firebase$_$config = firebase._.config,
      fileMetadataFactory = _firebase$_$config.fileMetadataFactory,
      useFirestoreForStorageMeta = _firebase$_$config.useFirestoreForStorageMeta,
      metadataFactory = options.metadataFactory,
      metaFactoryFunction = metadataFactory || fileMetadataFactory;
  return getDownloadURLFromUploadTaskSnapshot(uploadTaskSnapshot).then(function (downloadURL) {
    var fileData = "function" == typeof metaFactoryFunction ? metaFactoryFunction(uploadTaskSnapshot, firebase, uploadTaskSnapshot.metadata, downloadURL) : (0, _omitBy2.default)(uploadTaskSnapshot.metadata, _isUndefined2.default),
        resultFromSnap = createUploadMetaResponseHandler({
      fileData: fileData,
      firebase: firebase,
      uploadTaskSnapshot: uploadTaskSnapshot,
      downloadURL: downloadURL
    });
    return function metaSetPromise(fileData) {
      if (useFirestoreForStorageMeta) return firebase.firestore().collection(dbPath).add(fileData);
      var newMetaRef = firebase.database().ref(dbPath).push();
      return newMetaRef.set(fileData).then(function () {
        return newMetaRef;
      });
    }(fileData).then(resultFromSnap);
  });
}

function uploadFileWithProgress(dispatch, firebase, _ref4) {
  var path = _ref4.path,
      file = _ref4.file,
      filename = _ref4.filename,
      meta = _ref4.meta,
      fileMetadata = _ref4.fileMetadata,
      uploadEvent = firebase.storage().ref("".concat(path, "/").concat(filename)).put(file, fileMetadata),
      unListen = uploadEvent.on(firebase.storage.TaskEvent.STATE_CHANGED, {
    next: function next(snapshot) {
      dispatch({
        type: FILE_UPLOAD_PROGRESS,
        meta: meta,
        payload: {
          snapshot: snapshot,
          percent: Math.floor(100 * (snapshot.bytesTransferred / snapshot.totalBytes))
        }
      });
    },
    error: function error(err) {
      dispatch({
        type: FILE_UPLOAD_ERROR,
        meta: meta,
        payload: err
      }), unListen();
    },
    complete: function complete() {
      unListen();
    }
  });
  return uploadEvent;
}